import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles.css";
import { POCA_VENDOR, type PocaConfig } from "./types";

const MOUNT_ID = "poca-vendor-page-root";

function mount() {
  console.log("[poca] bundle loaded, attempting mount…");

  const el = document.getElementById(MOUNT_ID);
  if (!el) {
    console.warn(
      `[poca] mount node #${MOUNT_ID} not found — is the section rendered on this page?`
    );
    return;
  }
  console.log("[poca] mount node found:", el);

  const config = readConfig(el);
  console.log("[poca] config:", config);

  if (!config) {
    el.innerHTML =
      '<div class="poca-alert poca-alert--error">Storefront API configuration is missing. Check section settings (vendor + access token).</div>';
    return;
  }

  createRoot(el).render(
    <StrictMode>
      <App config={config} />
    </StrictMode>
  );
}

function readConfig(el: HTMLElement): PocaConfig | null {
  const fromWindow = window.__POCA_CONFIG__;
  const fromAttr = el.dataset.config;

  let parsed: Partial<PocaConfig> | null = fromWindow ?? null;
  if (!parsed && fromAttr) {
    try {
      parsed = JSON.parse(fromAttr) as Partial<PocaConfig>;
    } catch (e) {
      console.error("[poca] invalid data-config", e);
    }
  }

  if (!parsed) return null;

  const config: PocaConfig = {
    vendor: POCA_VENDOR,
    storefrontDomain: parsed.storefrontDomain ?? "",
    storefrontAccessToken: parsed.storefrontAccessToken ?? "",
    storefrontApiVersion: parsed.storefrontApiVersion ?? "2024-10",
    pageSize: parsed.pageSize ?? 24,
    enableSearch: parsed.enableSearch ?? true,
    enableSort: parsed.enableSort ?? true,
    enablePriceFilter: parsed.enablePriceFilter ?? true,
    enableAvailabilityFilter: parsed.enableAvailabilityFilter ?? true,
    enableAddToCart: parsed.enableAddToCart ?? true,
    // 프로모션 배너. 테마 에디터 토글이 없거나 꺼져 있으면 숨김
    showBulkDeal: parsed.showBulkDeal ?? false,
    discountPercent: parsed.discountPercent ?? 0,
    discountLabel: parsed.discountLabel ?? "SALE",
    currencyCode: parsed.currencyCode ?? "USD",
    countryCode: parsed.countryCode ?? "US",
    locale: parsed.locale ?? "en-US",
    routesCartAdd: parsed.routesCartAdd ?? "/cart/add.js",
    collectionTitlePrefix: parsed.collectionTitlePrefix ?? "PC_",
  };

  if (!config.vendor || !config.storefrontDomain || !config.storefrontAccessToken) {
    return null;
  }
  return config;
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mount, { once: true });
} else {
  mount();
}
